import React, { useRef, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import Entry_1 from "../../assets/entry (1).png";
import Entry_2 from "../../assets/entry (2).png";
import black_Arrow from "../../assets/Next.gif"
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import logo from '../../assets/logo.png'
import { API_BASE_URL } from "../../config";  
/* ================= STYLES ================= */

const TopSection = styled(Box)(({ expanded }) => ({
  height: expanded ? "100vh" : "55vh",
  transition: "height 420ms cubic-bezier(.2,.9,.2,1)",
  backgroundColor: "#5E2A37",
  borderBottomLeftRadius: expanded ? 0 : 20,
  borderBottomRightRadius: expanded ? 0 : 20,
  overflow: "hidden",
  position: "relative",
  zIndex: expanded ? 100 : 10,
}));

const BottomSection = styled(Box)(({ expanded }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: expanded ? "100vh" : "50vh",
  transition: "height 420ms cubic-bezier(.2,.9,.2,1)",
  backgroundColor: "#fff",
  borderTopLeftRadius: expanded ? 0 : 20,
  borderTopRightRadius: expanded ? 0 : 20,
  overflow: "hidden",
  zIndex: expanded ? 30 : 10,
}));

/* ========== RIPPLE STYLES (PURE CSS) ========== */

const RippleContainer = styled(Box)(() => ({
  position: "relative",
  width: 200,
  height: 200,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const RippleCircle = styled("span")(({ size, delay, opacity }) => ({
  position: "absolute",
  width: size,
  height: size,
  borderRadius: "50%",
  backgroundColor: "rgba(255,255,255,1)",
  animation: "ripple 3s ease-in-out infinite",
  animationDelay: delay,
  opacity,
}));

/* ================= COMPONENT ================= */

export default function TwoSlideExpandable() {
  const { makeApiRequest } = useApiRequest();
  const [expandedTop, setExpandedTop] = useState(false);
  const [expandedBottom, setExpandedBottom] = useState(false);
  const startY = useRef(null);
  const THRESHOLD = 50;
  const generatedUUID = uuidv4();

  const navigate = useNavigate();
  const location = useLocation();
// Top-level URL params
const [urlSearchParams] = useSearchParams();
const route = urlSearchParams.get("route"); 
// route = "machineId=12&value=5FU8WZ"

// Parse the nested route string
const routeParams = new URLSearchParams(decodeURIComponent(route ?? ""));
const machineId = routeParams.get("machineId"); // "12"
const value = routeParams.get("value");          // "5FU8WZ"

  /* ========== SCROLL LOCK ========== */
  useEffect(() => {
    const prevent = (e) => e.preventDefault();
    document.body.style.overflow = "hidden";
    window.addEventListener("wheel", prevent, { passive: false });
    window.addEventListener("touchmove", prevent, { passive: false });

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("wheel", prevent);
      window.removeEventListener("touchmove", prevent);
    };
  }, []);

  /* ========== AUTO GUEST LOGIN ========== */
  useEffect(() => {
    if(!(localStorage.getItem("UserJWTAuth")))
    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/guest/login",
      method: "POST",
      data: { request: { clientId: null } },
      handleSuccess: (res) => {
        if (res.data.successful) {
          localStorage.setItem("uuid", generatedUUID);
          localStorage.setItem("UserJWTAuth", res.data.response.jwt);
           localStorage.setItem("Guest_OauthToken", res.data.response.jwt);
            localStorage.setItem("Guest_clientId", res.data.response.jwt);
           
          
        }
      },
    });
  }, []);

  /* ========== GESTURE HELPERS ========== */
  const handleStart = (y) => (startY.current = y);
  const handleEnd = (y) => {
    if (startY.current === null) return 0;
    const delta = startY.current - y;
    startY.current = null;
    return delta;
  };

  const topEnd = (delta) => {
    if (delta > THRESHOLD) {
      setExpandedTop(true);
      setExpandedBottom(false);
      setTimeout(() => {
        navigate(`/items?machineId=${machineId}&value=${value}&showItems=true`);
      }, 400);
    }
  };

  const bottomEnd = (delta) => {
    if (delta > THRESHOLD) {
      setExpandedBottom(true);
      setExpandedTop(false);
      setTimeout(() => {
        navigate(`/help&support`);
      }, 400);
    }
  };

  /* ================= RENDER ================= */

  return (
    <Box sx={{ height: "100vh", position: "relative", overflow: "hidden" }}>
   

      {/* RIPPLE KEYFRAMES */}
      <style>{`
        @keyframes ripple {
          0% {
            transform: scale(0.7);
            opacity: 0.6;
          }
          50% {
            transform: scale(1.15);
            opacity: 0.25;
          }
          100% {
            transform: scale(0.7);
            opacity: 0.6;
          }
        }
      `}</style>

      {/* ============ TOP (BROWN) PANEL ============ */}
      <TopSection
        expanded={expandedTop ? 1 : 0}
        onTouchStart={(e) => handleStart(e.touches[0].clientY)}
        onTouchEnd={(e) => topEnd(handleEnd(e.changedTouches[0].clientY))}
        onMouseDown={(e) => handleStart(e.clientY)}
        onMouseUp={(e) => topEnd(handleEnd(e.clientY))}
        onClick={() => {
          setExpandedTop(true);
          setExpandedBottom(false);
          setTimeout(() => navigate(`/items?machineId=${machineId}&value=${value}&showItems=true`), 400);
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
             <img src={logo} style={{position:"absolute",width:"50px",top:"30px",left:"30px"}}/>
          {/* ===== PURE CSS RIPPLE ===== */}
          <RippleContainer sx={{ }}>
          {/*   <RippleCircle size={100} delay="0s" opacity={0.15} />
            <RippleCircle size={80} delay="0s" opacity={0.15} /> */}
            <RippleCircle size={120} delay="0.8s" opacity={0.25} />
            <RippleCircle size={120} delay="0.4s" opacity={0.4} />
            <RippleCircle size={120} delay="0.6s" opacity={0.6} />
            <div style={{background:"#c4c3c340",borderRadius:"80px",width:"135px",height:"135px",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <div style={{background:"white",borderRadius:"50px",width:"100px",height:"100px",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <img src={Entry_2} style={{ width: 90, zIndex: 2 ,}} />
            </div>
            </div>
          </RippleContainer>

          <Typography sx={{ color: "#fff", fontSize: 18, }}>
            Order Now
          </Typography>
          <Typography sx={{ color: "#fff", fontSize: 13, textDecoration: "underline" }}>
            Tap to view products
          </Typography>
        </Box>
      </TopSection>

      {/* ============ BOTTOM (WHITE) PANEL ============ */}
      <BottomSection
        expanded={expandedBottom ? 1 : 0}
        onTouchStart={(e) => handleStart(e.touches[0].clientY)}
        onTouchEnd={(e) => bottomEnd(handleEnd(e.changedTouches[0].clientY))}
        onMouseDown={(e) => handleStart(e.clientY)}
        onMouseUp={(e) => bottomEnd(handleEnd(e.clientY))}
        onClick={() => {
          setExpandedBottom(true);
          setExpandedTop(false);
          setTimeout(() => navigate(`/help&support`), 400);
        }}
      >
        {!expandedBottom && (
          <Box sx={{ position: "absolute", top: 10, width: "100%", textAlign: "center" ,display:"flex",justifyContent:"center"}}>
            <img src={black_Arrow} style={{ width: 50, transform: "rotate(-90deg)" }} />
          </Box>
        )}

        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          <img src={Entry_1} style={{ width: 50 }} />
          <div style={{marginTop:"30px"}}>

          <Typography sx={{ color: "#5E2A37", fontSize: 18 }}>
            Help & Support
          </Typography>
          <Typography sx={{ color: "#5E2A37", fontSize: 13, textDecoration: "underline" }}>
            Tap to get assistance
          </Typography>
          </div>
        </Box>
      </BottomSection>
    </Box>
  );
}
